module.exports = __webpack_public_path__ + "static/media/MichaelSherman@3x.a6384d59.png";